import React, { useState } from "react";
import { clamper } from "../../utils/clamper";
import { tryParseInt } from "../../utils/tryParseInt";
import events from "../../events";
import favoritesApiClient from "./FavoritesApiClient";
import basketApiClient from "../../basket/apiClient";
import styles from "./MyPageFavorites.module.scss";
export default function ProductGridItem({ item, strings, storeUrl }) {
    const itemUrl = `${storeUrl}${item.relativeUrl}`;
    const borderStyle = item.hasLongerDelivery || item.hasDiscount
        ? (item.hasDiscount ? styles.discount : styles.longerDelivery)
        : null;
    return (React.createElement("div", { className: `${styles.productItem} ${borderStyle}` },
        React.createElement("a", { className: styles.productImageContainer, href: itemUrl },
            React.createElement("img", { src: item.imageUrl })),
        React.createElement("a", { className: styles.productTextContainer, href: itemUrl },
            React.createElement("span", { className: styles.productTitle }, item.title),
            React.createElement("span", { className: styles.articleNr },
                strings.articleNr,
                React.createElement("span", { className: styles.underline }, item.sku)),
            React.createElement("span", { className: styles.textDescription }, item.description)),
        React.createElement(BuyModule, { value: 1, max: 10, product: item, buttonText: strings.buyButton }),
        React.createElement(FavoriteCheck, { sku: item.sku }),
        React.createElement("div", { className: styles.productInfoBadge },
            item.hasDiscount
                ? React.createElement("div", { className: `${styles.badgeBox} ${styles.discont}` },
                    React.createElement("span", null,
                        strings.saleText,
                        " - ",
                        item.discountPercent,
                        " %")) : null,
            item.hasLongerDelivery
                ? React.createElement("div", { className: `${styles.badgeBox} ${styles.longerDelivery}` },
                    React.createElement("span", null, strings.longerDeliveryText)) : null)));
}
function FavoriteCheck({ sku }) {
    const handleClick = async () => {
        await favoritesApiClient.remove(sku);
        events.onUpdateMyFavorite.trigger(null);
    };
    return (React.createElement("button", { className: styles.favorite, onClick: handleClick },
        React.createElement("svg", { width: "20", height: "18", viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M14.56 0.813397C17.5583 0.827995 19.9854 3.25502 20 6.25341C20 11.7467 10 17.1867 10 17.1867C10 17.1867 0 11.6667 0 6.25341C0 3.249 2.43555 0.813397 5.44002 0.813397C7.27915 0.799054 8.99854 1.72408 10 3.26671C11.0084 1.73158 12.7233 0.808956 14.56 0.813397Z", fill: "#D7443E" }))));
}
function BuyModule({ value, max, product, buttonText }) {
    const [quantity, setQuantity] = useState(value);
    const [disabled, setDisabled] = useState(false);
    const clamp = clamper(1, max || 99);
    const sanitizeValue = (strValue, fallbackValue) => {
        const sanitized = strValue.replace(/\D+/, '');
        return clamp(tryParseInt(sanitized, fallbackValue));
    };
    const onDec = () => {
        setQuantity(clamp(quantity - 1));
    };
    const onInc = () => {
        setQuantity(clamp(quantity + 1));
    };
    const onInput = (event) => {
        setQuantity(sanitizeValue(event.target.value, quantity));
    };
    const onBlur = (event) => {
        setQuantity(clamp(event.target.value));
    };
    const addToBasket = () => {
        setDisabled(true);
        const request = {
            sku: product.sku,
            quantity: quantity
        };
        basketApiClient.addItem(request)
            .then(basket => {
            events.onBasketUpdated.trigger({ basket, products: [request] });
        })
            .finally(() => {
            setDisabled(false);
        });
    };
    return (React.createElement("div", { className: styles.purchaseModule },
        React.createElement("div", { className: styles.priceContainer }, product.hasDiscount
            ? React.createElement(React.Fragment, null,
                React.createElement("span", { className: styles.oldPrice }, product.priceText),
                React.createElement("span", { className: styles.discountPrice }, product.discountPriceText))
            : React.createElement(React.Fragment, null,
                React.createElement("span", null, product.priceText))),
        React.createElement("label", { className: styles.quantitySelector },
            React.createElement("input", { value: quantity, onInput: onInput, onBlur: onBlur }),
            React.createElement("div", { className: styles.quantityPicker },
                React.createElement("button", { className: styles.inc, onClick: onInc }),
                React.createElement("button", { className: styles.dec, onClick: onDec }))),
        React.createElement("button", { className: styles.purchaseButton, onClick: addToBasket, disabled: disabled }, disabled
            ? React.createElement("span", { className: styles.circleLoader })
            : React.createElement("span", null, buttonText))));
}
